
import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { FormatReference, WriteMethodTypes } from "../../../domain/format";

@Component
export default class FormatValidatableMixin extends Mixins() {
  async validateFormats(formats: FormatReference[], isWorkflow: boolean): Promise<boolean> {
    // 値が設定されていないときはチェックしない（この前段階で制御してほしい）
    if (!formats) { return true; }
    for (const format of formats) {
      const isOk = await this.validateFormat(format, isWorkflow);
      if (!isOk) { return false; }
    }
    return true;
  }

  async validateFormat(format: FormatReference, isWorkflow: boolean): Promise<boolean> {
    // 値が設定されていないときはチェックしない（この前段階で制御してほしい）
    if (!format) { return true; }
    return isWorkflow
      ? this.validateFormatForWorkflow(format)
      : this.validateFormatForDirect(format);
  }

  isExpectedWriteMethodType(format: FormatReference, isWorkflow: boolean): boolean {
    const writeMethodType = (!format || !format.writeMethodType)
      ? WriteMethodTypes.Default
      : format.writeMethodType;
    const expectedTypes = isWorkflow
      ? WriteMethodTypes.WorkflowDefaultTargets
      : WriteMethodTypes.DirectDefaultTargets;
    return Enumerable.from(expectedTypes).any(v => v === writeMethodType);
  }

  private async validateFormatForWorkflow(format: FormatReference): Promise<boolean> {
    if (format.writeMethodType === WriteMethodTypes.DirectWithConfirmDialog) {
      // 直接記載のみ（確認）
      const index = await this.$commonDialogs.confirmation.confirmDangerCancel(
        this.$wording.format.name + "選択",
        ["直接記載で運用される書類です。運用と異なりますがよろしいですか？"],
        "選択する"
      );
      if (index !== 0) { return false; }
    }
    if (format.writeMethodType === WriteMethodTypes.DirectOnly) {
      // 直接記載のみ（警告）
      this.$warn(this.$wording.format.name + "選択", "この書類は直接記載運用のみの書類です。");
      return false;
    }
    return true;
  }

  private async validateFormatForDirect(format: FormatReference): Promise<boolean> {
    if (format.writeMethodType === WriteMethodTypes.WorkflowWithConfirmDialog) {
      // WFのみ（確認）
      const index = await this.$commonDialogs.confirmation.confirmDangerCancel(
        this.$wording.format.name + "選択",
        ["ワークフローで運用される書類です。運用と異なりますがよろしいですか？"],
        "選択する"
      );
      if (index !== 0) { return false; }
    }
    if (format.writeMethodType === WriteMethodTypes.WorkflowOnly) {
      // WFのみ（警告）
      this.$warn(this.$wording.format.name + "選択", "この書類はワークフロー運用のみの書類です。");
      return false;
    }
    return true;
  }

  validateFormatWriteMethod(format: FormatReference, isWorkflow: boolean): boolean {
    if (!format) { return true; }
    if (isWorkflow && format.writeMethodType === WriteMethodTypes.DirectOnly) {
      // 直接記載のみ（警告）
      this.$suspend(this.$wording.format.name + "不正", "この書類は直接記載運用のみの書類です。");
      return false;
    }
    if (!isWorkflow && format.writeMethodType === WriteMethodTypes.WorkflowOnly) {
      // WFのみ（警告）
      this.$suspend(this.$wording.format.name + "不正", "この書類はワークフロー運用のみの書類です。");
      return false;
    }
    return true;
  }
}
